import { createSelector } from 'reselect';
import PredesTimelinessSummaryColumns from '../../containers/PredesTimelinessSummaryColumns';
import ReportDefinitions from '../../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime = state => state.reporting.PREDES_TIMELINESS_SUMMARY.metadata.generatedOnDateTime;

export const getIsLoading = state => state.reporting.PREDES_TIMELINESS_SUMMARY.isLoading;

export const getData = ReportDefinitions.PREDES_TIMELINESS_SUMMARY.getDataFunction();

export const getColumns = createSelector(getData, PredesTimelinessSummaryColumns);
